import ActionButton from './ActionButton'
import EmptyScreen from './EmptyScreen'
import {useAppDispatch, useGetRunningContext} from 'src/hooks'
import { setType } from 'src/app/modal'
import {addErrorSDKToast} from "../utils/helpers";

const HostEmptySession = () => {
  const dispatch = useAppDispatch()

  const openCreateModal = () => {
    dispatch(setType({ type: 'sessionCreate' }))
  }

  const onStartMeeting = async () => {
    try {
      await window.zoomSdk.launchAppInMeeting()
    } catch (err) {
      addErrorSDKToast(err)
    }
  }

  const { isLoading, runningContext } = useGetRunningContext()

  return (
    <EmptyScreen>
      { !isLoading && runningContext === 'inMeeting' && (
          <>
          <p className="mb-6">Create a session to start assigning badges</p>
          </>
      )}
      { !isLoading && runningContext !== 'inMeeting' && (
          <>
          <p className="mb-6">Create your first session when you start a meeting! You’ll be able to see your sessions here.</p>
            <ActionButton
                type="primary"
                padding="lg"
                ariaLabel="Start a meeting"
                onClick={onStartMeeting}
            >
              Start a meeting
            </ActionButton>
          </>
      )}
        { !isLoading && runningContext === 'inMeeting' && (
            <>
      <ActionButton
        type="primary"
        padding="lg"
        ariaLabel="Create a New Session"
        onClick={openCreateModal}
      >
        Create a New Session
      </ActionButton>
            </>
        )}
    </EmptyScreen>
  )
}

export default HostEmptySession
